let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("jbxE1"), load("7imUH"), load("kNFvF"), load("jOESs")]).then(() => parcelRequire('48ZOK'));